import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { registerApplication } from 'single-spa';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { PlatformCommunicatorAuthService } from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { PlatformEndpointService } from 'src/app/shared/shared.module';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import * as singleSpa from 'single-spa';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
var MicroEvidenteMasterComponent = /** @class */ (function () {
    function MicroEvidenteMasterComponent(headerService, authService, navigationService, loaderService, abreCuentasService, endpointService, channelCommunicatorService, validationHelperService, incomesService, postValidateService) {
        var _this = this;
        this.headerService = headerService;
        this.authService = authService;
        this.navigationService = navigationService;
        this.loaderService = loaderService;
        this.abreCuentasService = abreCuentasService;
        this.endpointService = endpointService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.validationHelperService = validationHelperService;
        this.incomesService = incomesService;
        this.postValidateService = postValidateService;
        this.headerService.show(false, false, true),
            this.authSso = {
                ally_name: this.abreCuentasService.getproductSelected().es,
                session_id: this.authService.getSessionId(),
                token: this.authService.getSSOInformation().accessToken,
                transaction_id: this.abreCuentasService.getTransactionId(),
                product_code: this.abreCuentasService.getproductSelected().product_code,
                channelID: this.channelCommunicatorService.getChannelId(),
            };
        this.controlFlow = {
            nextStep: function () {
                _this.loaderService.forceHide();
                _this.navigationService.nextStep();
            },
            previousStep: function () { return _this.navigationService.previousStep(); },
        };
        this.functions = {
            customerDataEvidente: function (value) { return _this.abreCuentasService.setCustomerData(value); },
            otherSimulationData: function (value) { return _this.abreCuentasService.setOtherEvidentenData(value); },
            isPepData: function (value) { return _this.abreCuentasService.setFiProperty('IsPEP', value); },
            downloadPdf: function (value) { return _this.channelCommunicatorService.getImpl().openPdf(value); },
            exitApp: function () { return _this.channelCommunicatorService.getImpl().redirectToLoginView(); },
            officeRedirect: function () { return _this.channelCommunicatorService.getImpl()
                .openPage(_this.endpointService.URLS.BRANCH_OFFICE, 5, _this.abreCuentasService.getPostlogin()); },
            backpage: function () { return _this.channelCommunicatorService.getImpl().redirectToLoginView(); },
            getProductsSelects: function () { return _this.abreCuentasService.getProductsSelects(); },
            getproductSelected: function () { return _this.abreCuentasService.getproductSelected(); },
            setProductsSelects: function (value) { return _this.abreCuentasService.setProductsSelects(value); },
            changeToPhase: function (value) { return _this.navigationService.changeToPhase(value); },
            loadApplicationFlow: function (value) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.navigationService.loadApplicationFlow(value)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            }); }); },
            getInfoClient: function (value) { return _this.abreCuentasService.setDataMFE(value); },
            setCustomerDataClient: function () { return _this.validationHelperService.setCustomerDataClient(); },
            setCustomerData: function (value) { return _this.abreCuentasService.setCustomerData(value); },
            setCurrentStep: function (value) { return _this.navigationService.setCurrentStep(value); },
            switchFunction: function (value) { return _this.postValidateService.switchFunction(value); },
            setListClientProduct: function (value) { return _this.abreCuentasService.setListClientProduct(value); },
            setClientProduct: function (value) { return _this.abreCuentasService.setClientProduct(value); },
            getIsLogin: function () { return _this.abreCuentasService.getPostlogin(); },
            getDocumentInfo: function () { return _this.abreCuentasService.getDocumentInfo(); },
            setMultiView: function (value) { return _this.abreCuentasService.setMultiView(value); },
            setproductSelected: function (value) { return _this.abreCuentasService.setproductSelected(value); },
            callIncomes: function () { return _this.incomesService.callIncomes(); },
            getPhase: function (value1, value2) { return _this.navigationService.getPhase(value1, value2); },
            goToFlowSteps: function (value1, value2, value3) { return _this.navigationService.goToFlowSteps(value1, value2, value3); },
            flagGreyZone: function (flag) { return _this.abreCuentasService.setflagGreyZone(flag); },
        };
    }
    MicroEvidenteMasterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var status = singleSpa.getAppStatus('evidente');
        status === 'MOUNTED' ? singleSpa.unloadApplication('evidente') :
            registerApplication({
                name: 'evidente',
                app: function () { return System.import(_this.endpointService.MICROFRONTENDS.EVIDENTE); },
                activeWhen: '/',
                customProps: {
                    ssoProps: this.authSso,
                    controls: this.controlFlow,
                    loader: this.loaderService,
                    functions: this.functions,
                },
            });
    };
    MicroEvidenteMasterComponent.prototype.nextValidate = function () {
        var products = this.abreCuentasService.getProductsSelects();
        if (products.find(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; }) || products.find(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
            this.navigationService.nextStep('201');
        }
        else {
            this.navigationService.nextStep('200');
        }
    };
    return MicroEvidenteMasterComponent;
}());
export { MicroEvidenteMasterComponent };
